import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import ServicePageTemplate from "../components/ServicePageTemplate";
import SEO from "../components/SEO";
import { TRADFALLNING_FAQS } from "../data/faqs";
import { LOCAL_AREAS_LIST } from "../data/localAreas";

export default function Tradfallning() {
  return (
    <>
      <SEO
        title="Trädfällning i Laholm | Trädfällarna"
        description="Säker trädfällning i Laholm med omnejd. Trädfällarna hjälper privatpersoner, företag och fastigheter med trädfällning, sektionsfällning, stubbfräsning och bortforsling."
        path="/tradfallning"
      />
    <ServicePageTemplate
      eyebrow="Tjänst"
      title="Trädfällning i Laholm med omnejd"
      intro="Vi hjälper dig att fälla träd på ett säkert och kontrollerat sätt, oavsett om trädet står fritt eller nära hus, ledningar, vägar eller andra känsliga ytor."
      heroImage="/images/hero-tradfallning-2026.webp"
      heroImagePosition="55% 30%"
      bodyHeading="Rätt metod för rätt plats"
      bodyText="Varje träd och plats är unik. Därför gör vi alltid en bedömning av trädets storlek, lutning, omgivning och risker innan vi rekommenderar metod. Vi väljer alltid den lösning som är säkrast för platsen — och som lämnar tomten i fint skick."
      bullets={[
        {
          title: "Traditionell markfällning",
          text: "Trädet fälls i sin helhet när platsen tillåter — effektivt och kostnadseffektivt.",
        },
        {
          title: "Sektionsfällning",
          text: "Trädet kapas ner bit för bit, ofta med klätterteknik. Bra vid trånga lägen.",
        },
        {
          title: "Kranbilsfällning",
          text: "Med kran kan vi lyfta ner stora sektioner kontrollerat — perfekt nära byggnader.",
        },
        {
          title: "Komplett uppdrag",
          text: "Vi kan ta hand om stubbfräsning och bortforsling i samma vända.",
        },
      ]}
      steps={[
        { title: "Bedömning", text: "Vi tittar på trädet, lutning, risker och omgivning." },
        { title: "Tydlig offert", text: "Du får veta metod, pris och hur RUT hanteras." },
        { title: "Säker fällning", text: "Vi utför arbetet med rätt utrustning och metod." },
      ]}
      extraSection={
        <section
          className="section-pad bg-[#F7F5F0]"
          data-testid="tradfallning-areas-section"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl mb-8 md:mb-10">
              <span className="eyebrow">Områden</span>
              <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1B2A1E] leading-tight">
                Trädfällning i fler orter runt Laholm
              </h2>
              <p className="mt-4 text-[#3a4338] text-lg leading-relaxed">
                Vi utgår från Laholm och hjälper även kunder i flera närliggande
                orter. Läs mer om hur vi arbetar i ditt område.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {LOCAL_AREAS_LIST.map((area) => (
                <Link
                  key={area.slug}
                  to={`/${area.slug}`}
                  data-testid={`tradfallning-area-${area.slug}`}
                  className="group flex items-center justify-between gap-4 bg-white border border-[#E2E0D8] hover:border-[#D95D2E] rounded-xl px-5 py-5 transition-colors"
                >
                  <span className="flex items-center gap-3 min-w-0">
                    <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-[#EFEBDF] text-[#D95D2E] shrink-0">
                      <MapPin className="w-4 h-4" />
                    </span>
                    <span className="font-heading font-bold text-[#1B2A1E]">
                      Trädfällning i {area.city}
                    </span>
                  </span>
                  <ArrowRight className="w-4 h-4 text-[#D95D2E] shrink-0 group-hover:translate-x-1 transition-transform" />
                </Link>
              ))}
            </div>
          </div>
        </section>
      }
      faqId="tradfallning-faq"
      faqTitle="Vanliga frågor om trädfällning"
      faqItems={TRADFALLNING_FAQS}
    />
    </>
  );
}
